/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';
export const RENEW_CSME_CERTIFICATE = gql`
  mutation RenewCSMECertificate($credentialNo: String!) {
    renewCSMECertificate(credentialNo: $credentialNo) {
      createdAt
      updatedAt
      appliedOn
      applicant
      applicantInfo {
        vuid
        userId
        email
        firstName
        middleName
        lastName
        fullName
        emailVerified
        phoneVerified
        image
        accountStatus
        bannerImg
        address {
          addressLine1
          addressLine2
          addressLine3
          city
          state
          zipcode
          country
          parish
        }
        occupation
        bio
        primaryContactNo
        nationality

        createdAt
        alias
        childrenOrDependent
        gender
        maritalStatus
        passportExpiry
        passportNumber
        passportType
        placeOfBirth
        qualification {
          institute
          from
          to
          degree
          description
        }
        skills
        trn
        dateOfBirth
        declaration {
          selected
          value
        }
        lastEmployer {
          address {
            addressLine1
            addressLine2
            addressLine3
            city
            country
            parish
            state
            zipcode
          }
          country
          dateOfRegistration
          declaration {
            selected
            value
          }
          description
          email
          fax
          incorporationDate
          isSubsidiary
          logo
          name
          natureOfBusiness
          operatingAddress {
            addressLine1
            addressLine2
            addressLine3
            city
            country
            parish
            state
            zipcode
          }
          orgId
          primaryContactNo
          registrationNo
          socialLinks
          status
          tradingName
          trn
          type
          website
          workPermitIsInRelationTo
          credentialNo
          wpExpiry
        }
        permissionPeriod {
          from
          to
        }
        spouseName
        spouseNationality
        spouseLastEmployer {
          address {
            addressLine1
            addressLine2
            addressLine3
            city
            country
            parish
            state
            zipcode
          }
          country
          dateOfRegistration
          declaration {
            selected
            value
          }
          description
          email
          fax
          incorporationDate
          isSubsidiary
          name
          natureOfBusiness
          operatingAddress {
            addressLine1
            addressLine2
            addressLine3
            city
            country
            parish
            state
            zipcode
          }
          primaryContactNo
          registrationNo
          status
          tradingName
          trn
          type
          website
          workPermitIsInRelationTo
          credentialNo
          wpExpiry
        }
        countryConvicted
        criminalOffence
        dateOfConviction
        natureOfOffence
        workedInJamaica
        workExperience {
          from
          to
          jobDuty
          nameOfOrganization
          refLetter
        }
        dependentInfo {
          dependentType
          name
          passportNumber
          relationship
          age
          documents {
            expiry
            fileType
            name
            src
            type
          }
          gender
          nationality
        }
        isLastNameExist
        destinationCarribbeanState
        natureOfBusiness
        natureOfProfessionalActivity
        purposeOfRelocation
        isFirstNameChange
        isDependentExist
        isMailingAddressSame
        isMiddleNameChange
        isNameChange
        isNationalityChange
        isOccupationChange
        isPassportExpired
      }
      applicationNo
      appliedBy
      comment
      documents {
        name
        type
        src
        fileType
        expiry
      }
      employerInfo {
        orgId
        name
        tradingName
        description
        email
        registrationNo
        trn
        incorporationDate
        type
        dateOfRegistration
        fax
        operatingAddress {
          addressLine1
          addressLine2
          addressLine3
          city
          state
          zipcode
          country
          parish
        }
        natureOfBusiness
        website
        primaryContactNo
        address {
          addressLine1
          addressLine2
          addressLine3
          city
          state
          zipcode
          country
          parish
        }
        logo
        country
        status
        isSubsidiary
        workPermitIsInRelationTo
        saffCompsition {
          citizenship
          professional
          clerksOrServiceWorker
          skilledWorkers
          plantAndMachineOperators
          elementaryOccupations
          total
        }
        credentialNo
        wpExpiry
        tccExpiryDate
        tccNumber
      }
      jobInfo {
        JobTitle
        description
        necessaryQualification
        salaryOffered
        allowances {
          house
          car
          entertainment
          other
        }
        currency
        stepsForJaimacan {
          internalRecruitment

          didJamaicanApply
          appliedCandidates
          noStepTaken
          reasonNoneHired
          byAdvertisement
        }
        JobId
        benefitsReceived
        jobDuties
        registeredLMIS
        workingHours
      }
      status
      type
      educationInfo {
        dateOfIssued
        highEducationQualification
        institutionInfo {
          addressOfInstitution {
            addressLine2
            addressLine1
            city
            country
            parish
            zipcode
          }
          nameOfInstitution
        }
        nameOfQualification
      }
      employmentInfo {
        employment {
          email
          employerAddress {
            addressLine1
            addressLine2
            city
            country
            parish
            zipcode
          }
          employerName
          natureOfBusiness
          primaryContactNo
        }
        employmentStatus
        selfEmployment {
          address {
            addressLine2
            addressLine1
            city
            country
            parish
            zipcode
          }
          occupation
        }
        student {
          degreeOrCertificate
          educationType
          email
          institutionInfo {
            addressOfInstitution {
              addressLine1
              addressLine2
              country
              city
              parish
              zipcode
            }
            nameOfInstitution
          }
          primaryContactNo
        }
      }
    }
  }
`;
